export default __webpack_public_path__ + "static/media/trash.08e87c68.svg";